import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = { replaceExisting: Boolean }

  connect() {
    if (!this.hasSelectTarget) return
    if (this.selectTarget.value && !this.replaceExistingValue) return
    if (!window.Intl) return

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!timezone) return

    const option = Array.from(this.selectTarget.options).find((option) => option.value === timezone)
    if (option) {
      this.selectTarget.value = timezone
      this.selectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
